import { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const PaymentPageContext = createContext({});

export const PaymentPageProvider = (props) => {
  const { children, initialOrderFromPayload } = props;
  const [order, setOrder] = useState(initialOrderFromPayload);

  const refreshOrderData = (orderData) => {
    setOrder(orderData);
  };

  const value = useMemo(
    () => ({
      order,
      refreshOrderData,
    }),
    [order]
  );

  return <PaymentPageContext.Provider value={value}>{children}</PaymentPageContext.Provider>;
};

PaymentPageProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  initialOrderFromPayload: PropTypes.object,
};
